module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-45.4470b860.jpg";